<div class="sap-container">
    <label class="sap-title">
        <span [i18n]="titleLabelKey"></span>
        <span *ngIf="secondPartTitleLabelKey != undefined">
            -
            <span [i18n]="secondPartTitleLabelKey"></span>
        </span>
    </label>
    <app-switcher-form
        [disabled]="configurationDisable"
        [(ngModel)]="configurationAvailable"
        (ngModelChange)="valueChange.emit($event)">
    </app-switcher-form>
</div>
<div *ngIf="configurationAvailable">
    <small class="help-block m-b-none" [translate]="subTitleLabelKey"></small>
</div>
